import { render, staticRenderFns } from "./DocumentTabs.vue?vue&type=template&id=4fe554b4&scoped=true"
import script from "./DocumentTabs.vue?vue&type=script&lang=js"
export * from "./DocumentTabs.vue?vue&type=script&lang=js"
import style0 from "./DocumentTabs.vue?vue&type=style&index=0&id=4fe554b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe554b4",
  null
  
)

export default component.exports